import { render } from "./Administratie.vue?vue&type=template&id=98aa14a4"
import script from "./Administratie.vue?vue&type=script&lang=js"
export * from "./Administratie.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__